import { Routes, Route, Navigate } from 'react-router-dom'
import { useAuthStore } from './store/auth'
import Login from './pages/Login'
import TeacherDashboard from './pages/teacher/Dashboard'
import StudentDashboard from './pages/student/Dashboard'
import AssignmentCreate from './pages/teacher/AssignmentCreate'
import AssignmentList from './pages/teacher/AssignmentList'
import Submissions from './pages/teacher/Submissions'
import StudentAssignmentList from './pages/student/AssignmentList'
import AssignmentSubmit from './pages/student/AssignmentSubmit'
import Layout from './components/Layout'

function App() {
  const { user, isAuthenticated } = useAuthStore()

  if (!isAuthenticated) {
    return (
      <Routes>
        <Route path="/login" element={<Login />} />
        <Route path="*" element={<Navigate to="/login" replace />} />
      </Routes>
    )
  }

  return (
    <Layout>
      <Routes>
        {user?.role === 'teacher' ? (
          <>
            <Route path="/" element={<TeacherDashboard />} />
            <Route path="/assignments" element={<AssignmentList />} />
            <Route path="/assignments/create" element={<AssignmentCreate />} />
            <Route path="/submissions" element={<Submissions />} />
          </>
        ) : (
          <>
            <Route path="/" element={<StudentDashboard />} />
            <Route path="/assignments" element={<StudentAssignmentList />} />
            <Route path="/assignments/:id/submit" element={<AssignmentSubmit />} />
          </>
        )}
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </Layout>
  )
}

export default App
